import React, { useState, useRef } from 'react';

const StudentSelectedHoursPopup = ({setShowStudentFreeHoursPopup, ScheduleTimeTable}) => {
    const handleCancelPopupClick = () =>{
        setShowStudentFreeHoursPopup(false)
      }

      // Step 1: Extract all unique days (keys of object)
    const weekdays = Object.keys(ScheduleTimeTable);

    // Step 2: Extract all unique time slots
    const allTimeSlots = Array.from(
        new Set(
        weekdays.flatMap((day) => ScheduleTimeTable[day] || [])
        )
    );
  
  return (
  <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[20px] pt-[20px] shadow-lg w-[400px] 2.5xl:w-[500px]"> 
            <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={handleCancelPopupClick}
              />
            </div>

            <div className="flex flex-col gap-[15px]">
                <div className="flex justify-between ">
                    <p className="text-[16px] text-[#696974] font-semibold">Learner Free Hours</p>
                </div>

                <div className="w-full flex flex-col gap-[10px] pb-[10px]">
                    {Object.entries(ScheduleTimeTable)?.map(([day, times]) => (
                        times.length > 0 && (
                            <div key={day} className="flex gap-8">
                            <div className="w-[70px]">
                                <p className="text-[16px]">{day}</p>
                            </div>
                            <div className="flex gap-[5px]">
                                <span className="material-symbols-outlined text-[#A1A3EF]">
                                radio_button_checked
                                </span>
                                <div className="flex flex-col gap-2 text-[16px]">
                                {times.map((slot, index) => (
                                    <div key={index}>{slot}</div>
                                ))}
                                </div>
                            </div>
                            </div>
                        )
                    ))}

                </div>
            </div>
          
  </div>
  );
};

export default StudentSelectedHoursPopup;

